import React from 'react'
import Image1 from '../../images/program_1.png'
import Image2 from '../../images/program_2.png'
import Image3 from '../../images/last_img_main.png'
import { Link } from 'react-router-dom'

import { Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react'



import 'swiper/swiper.min.css'
import 'swiper/modules/pagination/pagination.min.css'


const data = [

    {
     image:  Image1,
      headline:"#7DODM",
      program: 'Our flagship digital marketing track: New cohort experience, coming soon. '
   
    }, 
  
    {
      image: Image2,
      headline:"Fundamentals of Design",
      program: 'Featured: Design Expert Orezi Mena virtual presentation design training.'

      }, 
  
      {
        image: Image3,
        headline:"Digi-House Party",
        program: 'Our Inaugural Digital-house part: Who says you can’t learn while having fun?  '
      },

    ]


    const PrivatePrograms = () => {

    return (
        <div className="program-container">

            <div className="program-txt">
                <h1 className="program-headline">Our <span className="green-span">programs</span> </h1>
                <h1 className="program-tagline">We specialise in hybrid (live, virtual, in-class) learning experiences
                 <br/> designed to help you advance your creative career & we also <br/> have fun while doing it.</h1>
                {/* <img src={Bg} alt="Background" className="dot-bg" /> */}

            </div>


            <div className="program-img">
                <div className="inner-img">
                    <img src={Image1} alt="program-1"/>
                    <h1 className="head-line">#7<span className="dodm">DODM</span> </h1>
                    <h1 className="prgm-txt">Our flagship digital marketing track: New cohort experience, coming soon.</h1>
                </div>

                <div className="inner-img">
                    <img src={Image2} alt="program-2"/>
                    <h1 className="head-line">Fundamentals of <span className="dodm">Design</span></h1>
                    <h1 className="prgm-txt">Featured: Design Expert Orezi Mena virtual presentation design training. </h1>
                </div>

                <div className="inner-img">
                    <img src={Image3} alt="program-3"/>
                    <h1 className="head-line">Digi-<span className="dodm">House Party</span></h1>
                    <h1 className="prgm-txt">Our Inaugral Digital-house part: Who says you can’t learn while having fun?</h1>
                </div>
            </div>


            
            <Swiper className="mProgram-img"

             modules={[Pagination]}
             spaceBetween={40}
             slidesPerView={1}
             navigation
             pagination={{ clickable: true }}
            
            >

             {
                 data.map(({image, headline, program}, index) => {

                     return(
                        <SwiperSlide className="mInner-img">
                        <img src={image} alt="program-1"/>
                        <h1 className="mHead-line">{headline} </h1>
                        <h1 className="mPrgm-txt">{program}</h1>
                    </SwiperSlide>

                     )
                
                
                })


            }
            
            </Swiper>

            <div className="join">
                <Link to="/login">
                    <button className="joinus-btnn">CHOOSE PROGRAMS</button>
                </Link>
            </div>
            
        
        </div>
    )
}

export default PrivatePrograms
